import React, { useEffect, useState } from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../../rules-regulations.css";
import API_URL from "../../config/constant";
export default function RulesRegulation() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/rules-regulations?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res);
            } catch (error) {
                setData(t("raceinfo.rr", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);

    return (
        <div className="text-white md:px-0 px-4 2xl:pb-96 lg:pb-96 md:pb-80 pb-40 bg-rulesRegistrationMobile md:bg-rulesRegistration bg-cover bg-no-repeat">
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("raceinfo.rrHeader")} />
            </div> */}
            <div className="relative top-24 md:top-40 2xl:px-0 md:px-14 px-0">
                <div className="basis-full py-8 max-md:max-w-[200px] max-md:text-wrap 2xl:p-16">
                    <span className="font-superWonder text-5xl md:text-8xl text-brandYellow">{t("raceinfo.rrHeader")}</span>
                </div>
                <div className="min-h-screen container mx-auto w-full font-poppins text-[#164481] bg-white rounded-3xl px-8 py-6">
                    <div className="flex items-start justify-start flex-col gap-y-10">
                        <p className="text-start md:w-1/2 font-medium text-xs text-brandGrey">{t("raceinfo.rrTitle")}</p>
                    </div>
                    <div className="flex md:flex-row flex-col gap-x-12 mt-10">
                        <div className="flex flex-col md:gap-y-10 gap-y-5 mb-10 pr-8 md:border-r border-brandYellow">
                            {data?.map((parent, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentIndex(index)}
                                    className={`uppercase text-start w-52 text-lg ${
                                        currentIndex === index
                                        ? "text-[#164481] font-bold max-md:border-b max-md:border-brandYellow"
                                        : "text-neutral-500 font-normal max-md:border-none"
                                    }`}
                                >
                                    {parent.title}
                                </button>
                            ))}
                        </div>
                        <div>
                            <ol className="font-light list-decimal leading-loose max-md:px-4">
                                {data && data[currentIndex].data && data[currentIndex].data.map((text, key) => <li className="text-justify" key={key} dangerouslySetInnerHTML={{ __html: text.desc }}></li>)}
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
